export const testemonials = [
  {
    content:
      " Vaš posao popravka nakita je apsolutno zadivljujući! Imate nevjerojatno oko za detalje i izvrstan osjećaj za izradu.",
    name: "Ivona P.",
  },
  {
    content:
      " Prsten je brzo i temeljito popravljen i izgleda kao nov. Impresionirana sam kvalitetom rada i toplo bih preporučila Calvi antique svakome tko traži popravak prstena za nakit.",
    name: "Vedrana S.",
  },
  {
    content:
      " Nedavno sam dala popraviti ogrlicu u Calvi antique i bila sam jako zadovoljna rezultatima. Uspjeli su je vratiti u prvobitno stanje i izgleda bolje nego ikada!",
    name: "Sanja T.",
  },
];
